/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetTwinTableOptionsEditor.vue?vue&type=template&id=fd38864a"
import script from "./widgetTwinTableOptionsEditor.vue?vue&type=script&lang=js"
export * from "./widgetTwinTableOptionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports